<template>
    <section class="about-section">
        <div class="section-container">

            <div class="about-content">
                <h2 class="section-title">文脉智造 · 数字共生</h2>
                <div class="divider"></div>
                <p class="section-text">
                    上海泓域文化传媒有限公司是一家专注于文化与技术深度融合的创新型企业。我们以数字技术为笔，以文化内核为墨，打造沉浸式、交互化的多媒体叙事体验。通过虚拟现实、人工智能、全息投影等前沿技术，为博物馆、文旅地标、品牌企业构建跨越时空的文化对话场景，让历史可触摸、让故事可参与、让未来可感知。
                </p>
            </div>
            <div class="icons-grid">
                <div v-for="(icon, index) in icons" :key="index" class="icon-item"
                     @mouseenter="startAnimation(index)"
                     @mouseleave="stopAnimation(index)">
                    <img :src="icon.static" :alt="'图标' + (index + 1)" ref="iconImages" class="icon-img" loading="lazy">
                </div>
            </div>

        </div>
    </section>
</template>

<script>
    export default {
        name: 'AboutSection',
        data() {
            return {
                icons: [
                    { static: require('../assets/materials/icons/icon1-static.svg'), frames: [] },
                    { static: require('../assets/materials/icons/icon2-static.svg'), frames: [] },
                    { static: require('../assets/materials/icons/icon3-static.svg'), frames: [] },
                    { static: require('../assets/materials/icons/icon4-static.svg'), frames: [] },
                    { static: require('../assets/materials/icons/icon5-static.svg'), frames: [] },
                    { static: require('../assets/materials/icons/icon6-static.svg'), frames: [] },
                    { static: require('../assets/materials/icons/icon7-static.svg'), frames: [] },
                    { static: require('../assets/materials/icons/icon8-static.svg'), frames: [] },
                ],
                animations: []
            };
        },
        methods: {
            startAnimation(index) {
                // 后续扩展：添加动画逻辑（如播放帧动画）
                console.log(`开始动画: 图标 ${index}`);
            },
            stopAnimation(index) {
                // 后续扩展：停止动画并恢复静态图
                console.log(`停止动画: 图标 ${index}`);
            }
        }
    };
</script>

<style scoped>
    .about-section {
        min-height: 100vh;
        padding: 80px 20px 40px;
        display: flex;
        align-items: center;
        background-color: #f9f9f9;
    }

    .section-container {
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        gap: 40px;
    }

    .icons-grid {
        flex: 1 1 500px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 20px;
    }

    .icon-item {
        background-color: white;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s ease;
        display: flex;
        justify-content: center;
        align-items: center;
    }

        .icon-item:hover {
            transform: translateY(-5px);
        }

    .icon-img {
        width: 100%;
        height: auto;
        max-width: 80px;
    }

    .about-content {
        flex: 1 1 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .section-title {
        font-size: 32px;
        color: #333;
        margin-bottom: 20px;
        text-align: center;
    }

    .divider {
        height: 1px;
        background: linear-gradient(to right, transparent, #ccc, transparent);
        margin: 20px 0;
    }

    .section-text {
        font-size: 16px;
        line-height: 1.8;
        color: #666;
    }

    /* 平板设备 */
    @media (max-width: 992px) {
        .section-container {
            flex-direction: column;
            align-items: center;
            text-align: center;
        }

        .icons-grid {
            grid-template-columns: repeat(3, 1fr);
            justify-items: center;
        }

        .about-content {
            width: 100%;
        }

        .section-title {
            font-size: 24px;
        }

        .section-text {
            font-size: 15px;
        }
    }

    /* 手机设备 */
    @media (max-width: 768px) {
        .icons-grid {
            grid-template-columns: repeat(2, 1fr);
        }

        .icon-img {
            max-width: 60px;
        }

        .section-title {
            font-size: 20px;
        }

        .section-text {
            font-size: 15px;
        }
    }
</style>